import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Register from './components/Register';
import AdminDashboard from './components/AdminDashboard';
import BarberDashboard from './components/BarberDashboard';
import Reservas from './components/Reservas/Reservas';
import ViewClient from './components/Reservas/View-clients/view_client';
import SessionExpiredModal from './components/SessionExpiredModal';
import { subscribeSessionExpired, resetSessionExpiredEmitter } from './utils/sessionExpired';

function SessionExpiredHost() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => subscribeSessionExpired(() => setOpen(true)), []);

  const handleGoToLogin = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    resetSessionExpiredEmitter();
    setOpen(false);
    navigate('/login', { replace: true });
  };

  return <SessionExpiredModal open={open} onGoToLogin={handleGoToLogin} />;
}

function App() {
  return (
    <Router>
      <SessionExpiredHost />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reservas" element={<Reservas />} />
        <Route path="/client" element={<ViewClient />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/:section" element={<AdminDashboard />} />
        <Route path="/barber" element={<BarberDashboard />} />
      </Routes>
    </Router>
  );
}

export default App
